import { Link } from 'react-router-dom';
import { mockPhotos } from '../../../mocks/gallery';

export default function GalleryTeaser() {
  const preview = mockPhotos.slice(0, 4);
  return (
    <section className="bg-[#111111] py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="font-heading font-light text-brand-orange tracking-[0.3em] uppercase text-xs mb-2">Photos &amp; Videos</p>
            <h2 className="font-display text-5xl md:text-6xl text-white tracking-wide">GALLERY</h2>
          </div>
          <Link to="/gallery" className="whitespace-nowrap font-heading font-semibold text-xs tracking-widest uppercase text-brand-yellow border border-brand-yellow px-6 py-2.5 hover:bg-brand-yellow hover:text-black transition-colors duration-200 cursor-pointer">
            View All
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {preview.map((photo) => (
            <Link to="/gallery" key={photo.id} className="group relative w-full h-0 pb-[100%] overflow-hidden cursor-pointer block">
              <img src={photo.imageUrl} alt={photo.title} className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <i className="ri-zoom-in-line text-white text-2xl" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
